/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".icon_338926ca{display:block;overflow:visible}\n"}]);
export const icon = "icon_338926ca";